import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class InvoicedJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getInvoicedReportUrl:'/api/v1/portal/portal-admin/invoiced-jobs-report',
            InvoicedJobsReportData:[],
            downloadReportName:'Invoiced Jobs Report',
            selectedCustomers:[],
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((customer)=>{
                options.push({
                    label : customer.company.short_name+'-'+customer.name,
                    value : customer.id
                });
            });
            this.setState({
              customers: options,
              isLoading: false
            });
          });
        });
      }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({selectedCustomers});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            customer_ids: this.state.selectedCustomers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                InvoicedJobsReportData: response,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        filename = filename+' From '+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+'.xlsx';
        let url = "/api/v1/portal/finance/invoiced-job-report";
            return fetch(url,{
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Authorization": 'Bearer ' + window.api_token,
                    "Accept": 'application/json',
                },
                body: JSON.stringify({
                    customer_ids: this.state.selectedCustomers,
                    start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
                    end_date:moment(this.state.endDate).format("YYYY-MM-DD")
                }),
            }
            ).then(response => response.blob())
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a); 
                    a.click();    
                    a.remove(); 
                }).catch(err=>{
                    alert('sorry something went wrong.');
                });
      }
    render() {
        let invoicedJobs = [];
        const {selectedCustomers} = this.state;
        let downloadableCsvDataInvoiced = "Job Ref,DATE,DRIVER,Reg/VIN,Customer,From Address,To Address,MILES,Job price,DRIVER PRICE,FUEL,FUEL INCL,EXPENSES APP,ADMIN FEE,Invoice Number\n";
        if(this.state.InvoicedJobsReportData.length > 0){
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;
                let expenses_approval_price = parseFloat(currentJob.expenses_approval_price).toFixed(2);
                let expenses_approval_fuel_total = parseFloat(currentJob.expenses_approval_fuel_total).toFixed(2);
                let totalPrice = parseFloat(currentJob.job_price) + parseFloat(expenses_approval_price);
                totalPrice = parseFloat(totalPrice).toFixed(2);
                // invoicedJobs.push(
                //         <tr key={index}>
                //             <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                //             <td>{currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}</td>        
                //             <td>{currentJob.customer.name}</td>        
                //             <td>{currentJob.pickup_address.address_line_1}</td>        
                //             <td>{currentJob.dropoff_address.address_line_1}</td>        
                //             <td>&pound;{currentJob.job_price}</td>
                //             <td>&pound;{expenses_approval_price}</td>        
                //             <td>{ (currentJob.invoice_date) ? moment(currentJob.invoice_date).format("DD.MM.YY") : ""}</td>        
                //             <td>{currentJob.invoice_number}</td>
                //             <td>&pound;{totalPrice}</td>     
                //         </tr>
                // );
                invoicedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                        <td>{ (currentJob.driver_completed_at) ? moment(currentJob.driver_completed_at).format("DD.MM.YY") : ""}</td> 
                        <td>{(currentJob.driver) ? currentJob.driver.user.full_name : ''}</td>
                        <td>{currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}</td>        
                        <td>{currentJob.customer.name}</td>
                        <td>{((currentJob.pickup_address)&&(currentJob.pickup_address.address_line_1))?currentJob.pickup_address.address_line_1:''}</td>        
                        <td>{((currentJob.dropoff_address)&&(currentJob.dropoff_address.address_line_1))?currentJob.dropoff_address.address_line_1:''}</td>
                        <td>{currentJob.distance_in_miles}</td>
                        <td>&pound;{currentJob.job_price}</td>
                        <td>&pound;{currentJob.driver_price}</td>
                        <td>&pound;{expenses_approval_fuel_total}</td>

                        <td>&pound;{(currentJob.vehicle_movements/100).toFixed(2)}</td>
                        <td>&pound;{(currentJob.toll_road/100).toFixed(2)}</td>
                        <td>&pound;{(currentJob.waitingtime/100).toFixed(2)}</td>
                        <td>&pound;{(currentJob.storage/100).toFixed(2)}</td>
                        <td>&pound;{(currentJob.breakdown/100).toFixed(2)}</td>
                        <td>&pound;{(currentJob.travel/100).toFixed(2)}</td>
                        <td>&pound;{(currentJob.car_wash/100).toFixed(2)}</td>
                        <td>&pound;{(currentJob.parts/100).toFixed(2)}</td>
                        <td>&pound;{(currentJob.transport_services/100).toFixed(2)}</td>
                        <td>&pound;{(currentJob.hotel/100).toFixed(2)}</td>

                        <td>-&pound;{expenses_approval_price}</td> 
                        <td>{currentJob.fuel_included_in_job_price === 1 ? 'YES' : 'NO'}</td>
                        <td>{currentJob.admin_fee_in_pence / 100}</td>
                        <td>{currentJob.invoice_number}</td>    
                    </tr>
            );
            var pickupAddress = ((currentJob.pickup_address)&&(currentJob.pickup_address.address_line_1))?currentJob.pickup_address.address_line_1:'';
            var dropAddress = ((currentJob.dropoff_address)&&(currentJob.dropoff_address.address_line_1))?currentJob.dropoff_address.address_line_1:'';

            downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                            currentJob.id+','+
                                            ((currentJob.driver_completed_at) ? moment(currentJob.driver_completed_at).format("DD.MM.YY") : "")+','+
                                            ((currentJob.driver) ? currentJob.driver.user.full_name : '')+','+
                                            currentJob.vehicle.registration_number+','+
                                            currentJob.customer.name+','+
                                            pickupAddress+','+
                                            dropAddress+','+ 
                                            currentJob.distance_in_miles+','+
                                            currentJob.job_price+','+
                                            currentJob.driver_price+','+
                                            expenses_approval_fuel_total+','+

                                            ((currentJob.vehicle_movements/100).toFixed(2))+','+
                                            ((currentJob.toll_road/100).toFixed(2))+','+
                                            ((currentJob.waitingtime/100).toFixed(2))+','+
                                            ((currentJob.storage/100).toFixed(2))+','+
                                            ((currentJob.breakdown/100).toFixed(2))+','+
                                            ((currentJob.travel/100).toFixed(2))+','+
                                            ((currentJob.car_wash/100).toFixed(2))+','+
                                            ((currentJob.parts/100).toFixed(2))+','+
                                            ((currentJob.transport_services/100).toFixed(2))+','+
                                            ((currentJob.hotel/100).toFixed(2))+','+

                                            (currentJob.fuel_included_in_job_price === 1 ? 'YES' : 'NO')+','+
                                            expenses_approval_price+','+
                                            currentJob.admin_fee_in_pence / 100+','+
                                            currentJob.invoice_number+"\n";
            });
        }else{
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="26" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Invoiced Jobs Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.customers}
                                    selected={selectedCustomers}
                                    onSelectedChanged={this.handleCustomerSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Customers...",
                                            allItemsAreSelected: "All Customers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Customer",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Invoiced Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Invoiced Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.InvoicedJobsReportData.length} jobs found..</b></label></div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        {/* <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>From Address</th>
                                        <th>To Address</th>
                                        <th>Job price</th>
                                        <th>Expenses price</th>
                                        <th>Invoice Date</th>
                                        <th>Invoice Number</th>
                                        <th>Total</th> */}

                                        <th>Job Ref</th>
                                        <th>DATE</th>
                                        <th>Driver</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>From Address</th>
                                        <th>To Address</th>
                                        <th>Miles</th>
                                        <th>Job price</th>
                                        <th>Driver price</th>
                                        <th>Fuel</th>

                                        <th>Vehicle Movements</th>
                                        <th>Toll Road</th>
                                        <th>Waitingtime</th>
                                        <th>Storage</th>
                                        <th>Breakdown</th>
                                        <th>Travel</th>
                                        <th>Car Wash</th>
                                        <th>Parts</th>
                                        <th>Transport Services</th>
                                        <th>Hotel</th>

                                        <th>Expenses App</th>
                                        <th>Fuel INCL</th>
                                        <th>Admin Fee</th>
                                        <th>Invoice Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="26"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    invoicedJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-invoiced_jobs_report')) {
    ReactDOM.render(
        <InvoicedJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-invoiced_jobs_report')
    );
}
